export default __webpack_public_path__ + "50a28664d0b760594d13640a328e2352.png";